import React, { useState } from "react";
import { ArrowRight, Loader2 } from "lucide-react";
import api, { formatErr } from "@/lib/api";
import { toast } from "sonner";
import { SERVICES } from "@/lib/siteData";
import { useLang } from "@/context/LangContext";

const EMPTY = { company_name: "", email: "", goods_type: "", message: "" };
const inputCls = "w-full rounded-md bg-white border border-slate-200 px-3 py-2.5 text-sm text-[#0b2545] placeholder:text-slate-500 focus:outline-none focus:border-[#f26b1d]";

export default function QuickQuoteForm({ kind = "Demande de devis", testid = "quick-quote", subject = false }) {
    const { t, lang } = useLang();
    const [f, setF] = useState(EMPTY);
    const [loading, setLoading] = useState(false);
    const up = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
    const typeLabel = subject ? t("Sujet", "Subject") : t("Type de transport", "Transport type");

    const submit = async (e) => {
        e.preventDefault();
        if (!f.goods_type) {
            toast.error(t(`Veuillez choisir : ${typeLabel.toLowerCase()}`, `Please choose: ${typeLabel.toLowerCase()}`));
            return;
        }
        setLoading(true);
        try {
            const tag = lang === "en" ? `[${kind}] [EN]` : `[${kind}]`;
            await api.post("/public/quote", { ...f, contact_name: f.company_name, message: `${tag} ${f.message}` });
            toast.success(t("Demande envoyée. Notre équipe revient vers vous rapidement.", "Request sent. Our team will get back to you shortly."));
            setF(EMPTY);
        } catch (err) {
            toast.error(formatErr(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={submit} className="space-y-3" data-testid={`${testid}-form`}>
            <input data-testid={`${testid}-name`} required value={f.company_name} onChange={up("company_name")} placeholder={t("Nom / Société *", "Name / Company *")} className={inputCls} />
            <input data-testid={`${testid}-email`} required type="email" value={f.email} onChange={up("email")} placeholder="Email *" className={inputCls} />
            <select data-testid={`${testid}-type`} value={f.goods_type} onChange={up("goods_type")} className={inputCls}>
                <option value="">{typeLabel} *</option>
                {SERVICES.map((s) => <option key={s.slug} value={s.title}>{t(s.title, s.titleEn)}</option>)}
                <option value="Autre demande">{t("Autre demande", "Other request")}</option>
            </select>
            <textarea data-testid={`${testid}-message`} rows={3} value={f.message} onChange={up("message")} placeholder={t("Message (optionnel)", "Message (optional)")} className={inputCls} />
            <button type="submit" disabled={loading} data-testid={`${testid}-submit`} className="kz-btn-primary w-full justify-center">
                {loading && <Loader2 className="animate-spin" size={16} />} {t("Envoyer ma demande", "Send my request")} <ArrowRight size={15} />
            </button>
        </form>
    );
}
